import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { toCamelCase } from "utils/Utils";

const BankDetails = ({ classes, bankDetails }) => {
    console.log(bankDetails,"fkafjka")
  const itemView = (label, value) => {
    return (
      <Grid item xs={12} sm={6} md={3} className={classes.fieldContainer}>
        <p style={{ marginBottom: 0 }}>
          <b>{label}</b>
        </p>
        <label>{value}</label>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      {/* Title */}
      <Grid item xs={12} className={classes.inputFieldContainer}>
        <h2 className={classes.header} style={{ fontSize: "1.5rem" }}>
          Bank Details
        </h2>
      </Grid>

      {/* Reference Details List */}
      <Grid item xs={12} container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer} spacing={2}>
                {itemView("Account Number", toCamelCase(bankDetails?.bankAccountNo) || "NA")}
                {itemView("IFSC Code", toCamelCase(bankDetails?.ifscCode) || "NA")}
                {itemView("Bank Name", toCamelCase(bankDetails?.bankName) || "NA")}
                {itemView("Beneficiary Name", toCamelCase(bankDetails?.beneficiaryName) || "NA")}
                {itemView("Branch Name", toCamelCase(bankDetails?.branch) || "NA")}
                {itemView("Bank Address", toCamelCase(bankDetails?.branchAddress) || "NA")}
                {itemView("Match Score", bankDetails?.matchScore || "NA")}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

BankDetails.propTypes = {
  classes: PropTypes.object,
  bankDetails: PropTypes.arrayOf(
    PropTypes.shape({
      referalName: PropTypes.string,
      referalRelation: PropTypes.string,
      phoneNumber: PropTypes.string,
    })
  ),
};

export default BankDetails;
